<style scoped>
    @import url("../../styles/smartControl/cSmartControl.scss");
</style>

<template>
    <div class="box_cSC">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <!-- mdi-wrench-clock <--- para simbolizar automação -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-compare</v-icon>
            <span class="ml-2">Comparação de decisão</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <div class="painelGeral mt-1" v-if="flagMsgZero">
            <span>Sem dados para comparação</span>
        </div>

        <div class="painelGeral" v-if="!flagMsgSistema">

            <!--<CompDecisao v-for="(el,i) in liControlador" :key="i"
            :t="el.titulo" 
            :unid="el.unidade" 
            :iconEl="el.icon" 
            :marcador="el.sub_marcador"
            :status="el.status"

            :cliente="$store.state.emailCliente" 
            :sistema="$store.state.sistemaSC"

            :r="r4" 
            />-->

            Desabilitado

        </div>

    </div>
</template>

<script>
//import CompDecisao from './CompDecisao'

import axios from 'axios'

export default {

    //components:{CompDecisao},

    data() {
        return {
            
            // rota de montagem comparação
            r4:'/compareia',

            liAtuadores:[], // lista com el por atuador
            liControlador:[], // lista de controladores inserida na lista de atuadores 18/09/25

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
            flagMsgZero:false, // condiciona arranque do sistema (Sem dados para comparar)
        }
    },

    methods:{
        
        preInit() {

            this.sistema = this.$store.state.sistemaSC // v2 14/08/2025
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)

                const el = res.data.result // agent_unit
                self.liAtuadores = el['atuadores'] // lista de atuadores contendo controladores
                
                let c=0
                while ( c < self.liAtuadores.length ) {

                    self.liControlador = self.liAtuadores[c]['params']
                    let j=0
                    while (j < self.liControlador.length) {

                        if (self.liControlador[j]['status'] == 'off') { self.liControlador.splice(j, 1); }
                        else { j++ }   
                    }
                    c++
                }
                if ( self.liAtuadores.length == 1 && self.liAtuadores[0].params.length == 0) { 
                    self.flagMsgZero = true // na unica lista nao tem nada
                    // o sistema sempre inicia com uma lista de atuadores, mesmo sem nada config
                }
                else { self.flagMsgZero = false }
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
    }
}
</script>